export default "__VITE_ASSET__CJTUbhzJ__"